import {generatePopupHTML} from "app/common/PopupUtil";
import {countriesAndRegionsFieldConfig} from "app/countries/CountriesLayer";
import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const markerBaseOptions = {
    marker: "s",
    fillColor: "#ddc3b9",
    radius: 10,
    color: "#232323",
    addStroke: false,
    weight: 0,
    opacity: 1,
    fillOpacity: 1,
    pane: mapOverlayPanes[12],
    interactive: false,
};

export const LayerLegend = createLayerLegend({
    layerName: "Regions",
    menuIconShape: markerBaseOptions.marker,
    defaultMarkerOptions: markerBaseOptions,
});

const createRegionsTooltip = data => {
    return generatePopupHTML("Regions", data, countriesAndRegionsFieldConfig);
};

// eslint-disable-next-line no-unused-vars
export function useRegionsLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        detail: false,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            return createRegionsTooltip(data);
        },
    });
}
